import { render, staticRenderFns } from "./ProductApprovalNew.vue?vue&type=template&id=5e9d8f16&scoped=true"
import script from "./ProductApprovalNew.vue?vue&type=script&lang=js"
export * from "./ProductApprovalNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9d8f16",
  null
  
)

export default component.exports